/* eslint-disable brace-style */
import { makeAutoObservable } from 'mobx'
import type { StripeElementsOptionsMode } from '@stripe/stripe-js'

import { ShopRootStore } from 'shop/stores/shopRoot.store'
import { STIPE_ELEMENT_OPTIONS_DEFAULT } from 'constants/paymentSettingShared.constants'

import {
  StripeElementOptions,
  StripeElementsPayloads,
  StripePaymentElement,
} from '../../interfaces/payment-method-interfaces/StripePaymentMethod'

export class ShopStripeCardPaymentMethodStore implements StripePaymentElement, StripeElementOptions {
  storeName = 'ShopStripeCardPaymentMethodStore'
  root: ShopRootStore = null

  constructor(root: ShopRootStore) {
    this.root = root

    makeAutoObservable(this)
  }

  getStripeElementPayload = ({
    isDealsPage,
    isManagePage,
    mode,
  }: {
    isDealsPage: boolean
    isManagePage: boolean
    mode?: string
  }): StripeElementsOptionsMode => {
    let store: StripeElementsPayloads = null

    if (isDealsPage) {
      store = this.root.dealsStore
    } else if (isManagePage) {
      store = this.root.ordersStore
    } else {
      store = this.root.paymentStore
    }

    return (
      (store?.getStripeCardElementPayload && store.getStripeCardElementPayload(mode)) || STIPE_ELEMENT_OPTIONS_DEFAULT
    )
  }

  getPaymentElementOptions = () => ({
    fields: {
      billingDetails: 'never',
    },
    wallets: {
      googlePay: 'never',
      applePay: 'never',
    },
  })
}
